import { doubleToStringMonthly } from "../../../objects/CommonUse/double_functions";
import calculatePenaltyAmount from "../savings/objects/calculate_penalty_amount";

export const determineTransferFeeAndText = (savingsType, savingsClass, currentCD, savingInfoObj) => {
    let transferFeeDisplay = false;
    let transferFeeText = "";
    if ((savingsType === "CD" && currentCD === false) ||
        savingsClass === "retirement"){
        let transferFee = calculatePenaltyAmount(savingsType, savingsClass, savingInfoObj);
        if (transferFee > 0){
            transferFeeDisplay = true;
            if (savingsType === "CD"){
                transferFeeText = "A fee of " + doubleToStringMonthly(transferFee) +
                    " will be charged for this withdrawal.";
            }else{
                if (savingsClass === "retirement"){
                    transferFeeText = "A pre-paid tax amount of " +
                        doubleToStringMonthly(transferFee) +
                        " (20%) will be charged for this withdrawal. " +
                        " Additional amounts may be charged at the end of the year."
                }
            }
        }
       
    }
    const returnObj = {transferFeeDisplay: transferFeeDisplay, transferFeeText: transferFeeText};
    return returnObj;
}
export default determineTransferFeeAndText;